import axios from 'axios'
import VueCookies from 'vue-cookies'
import { BASE_URL, ACCESS_TOKEN } from '../constants'

axios.defaults.baseURL = BASE_URL
axios.defaults.paramsSerializer = (params) => {
  return Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      VueCookies.remove(ACCESS_TOKEN)
      window.location.href = '/auth/login'
    }
    return Promise.reject(error)
  },
)

const setToken = (token: string) => {
  axios.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )
}

export { axios, setToken }
